'use client';

import { useCallback } from 'react';
import { usePathname, useRouter } from '@/i18n/routing';

/**
 * Returns a click handler for an `href` that points to the current page: syncs the URL
 * (dropping query-driven overlays, e.g. the gamification bar) and smoothly scrolls to the top.
 * Returns `undefined` for other pages, so a regular link navigation is used.
 */
export function useSamePageScrollTopAction() {
  const pathname = usePathname();
  const router = useRouter();

  return useCallback((href?: string): VoidFunction | undefined => {
    if (!href || href !== pathname) {
      return undefined;
    }

    return () => {
      router.replace(href, { scroll: false });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };
  }, [pathname, router]);
}
